import React from 'react';
import { LayoutLogin } from 'shared/layout';
import { LoginWidget } from 'widgets/login/login.widget';

export const LoginPage = () => {
    return <LayoutLogin>
        <LoginWidget />
    </LayoutLogin>;
};
